import { takeEvery, fork, put, call, select } from 'redux-saga/effects';
import i18n from '@/../i18n';
import { ShowToast } from '@/store/toast/actions';
import {
    ActionTypes,
    PrebuildModulesAddStartAction,
    PrebuildModulesDeleteStartAction,
    PrebuildModulesEditStartAction,
} from '@/store/prebuildModules/types';
import {
    loadPrebuildModules as loadPrebuildModulesApi,
    addPrebuildModule as addPrebuildModuleApi,
    updatePrebuildModuleName as updatePrebuildModuleNameApi,
    deletePrebuildModule as deletePrebuildModuleApi,
} from '@/services/ApiCategories/prebuiltModules';
import {
    PrebuildModulesLoadSuccess,
    PrebuildModulesLoadError,
    getPrebuildModulesStore,
    PrebuildModulesAddSuccess,
    PrebuildModulesEditSuccess,
    PrebuildModulesDeleteSuccess,
} from '../store/prebuildModules/actions';
import { errorToast } from './commonGenerators/errorToast';

function* loadPrebuildModules(): any {
    try {
        const list = yield call(loadPrebuildModulesApi);
        if (list.status !== 200) {
            throw new Error(i18n.t('apitimeout'));
        }
        yield put(PrebuildModulesLoadSuccess(list.data));
    } catch (e) {
        yield put(PrebuildModulesLoadError());
        yield call(errorToast, e);
    }
}

function* addPrebuildModule(action: PrebuildModulesAddStartAction): any {
    try {
        const { module } = action.payload;
        const response = yield call(addPrebuildModuleApi, module);
        if (response.status !== 200) {
            throw new Error(i18n.t('apitimeout'));
        }
        yield put(PrebuildModulesAddSuccess(response.data));
        yield put(
            ShowToast({
                message: i18n.t('modulesaved'),
                severity: 'info',
                duration: 6000,
            })
        );
    } catch (e) {
        // yield put(PrebuildModulesAddError(action.payload.color));
        yield call(errorToast, e);
    }
}

function* editPrebuildModuleName(action: PrebuildModulesEditStartAction): any {
    try {
        const { id, newName } = action.payload;
        const { list } = yield select(getPrebuildModulesStore);
        const module = list.find((item) => item.Id === id);
        if (!module) {
            return;
        }
        const response = yield call(updatePrebuildModuleNameApi, module.Name, newName);
        if (response.status !== 200) {
            throw new Error(i18n.t('apitimeout'));
        }
        yield put(PrebuildModulesEditSuccess(response.data));

        yield put(
            ShowToast({
                message: i18n.t('modulenamesaved'),
                severity: 'info',
                duration: 6000,
            })
        );
    } catch (e) {
        yield call(errorToast, e);
    }
}

function* deletePrebuildModule(action: PrebuildModulesDeleteStartAction): any {
    try {
        const { id } = action.payload;
        const { list } = yield select(getPrebuildModulesStore);
        const module = list.find((item) => item.Id === id);
        if (!module) {
            return;
        }
        const response = yield call(deletePrebuildModuleApi, module.Name);
        if (response.status !== 200) {
            throw new Error(i18n.t('apitimeout'));
        }
        yield put(PrebuildModulesDeleteSuccess(response.data));
        yield put(
            ShowToast({
                message: i18n.t('moduledeleted'),
                severity: 'info',
                duration: 6000,
            })
        );
    } catch (e) {
        // yield put(PrebuildModulesDeleteError(action.payload.module));
        yield call(errorToast, e);
    }
}

function* loadPrebuildModulesWatcher(): any {
    yield takeEvery(ActionTypes.LOAD_START, loadPrebuildModules);
}

function* addPrebuildModuleWatcher(): any {
    yield takeEvery(ActionTypes.ADD_START, addPrebuildModule);
}

function* editPrebuildModuleNameWatcher(): any {
    yield takeEvery(ActionTypes.EDIT_START, editPrebuildModuleName);
}

function* deletePrebuildModuleWatcher(): any {
    yield takeEvery(ActionTypes.DELETE_START, deletePrebuildModule);
}

const prebuildModulesSagas = [
    fork(loadPrebuildModulesWatcher),
    fork(addPrebuildModuleWatcher),
    fork(deletePrebuildModuleWatcher),
    fork(editPrebuildModuleNameWatcher),
];

export default prebuildModulesSagas;
